const getBaseUrl = () => {
    const baseUrl = window.location.origin;
    const appUrl = process.env.VUE_APP_URL;
    return baseUrl+appUrl;
};

export default getBaseUrl;